/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
/*
  Error component for Page/Route Not Found
*/

import React from 'react';
import { Link } from 'react-router-dom';
import './Error.scss';
import Localized from '../../../shared/components/Localized';
import { footer } from '../../../config'

const Error = props => {
  const errorCode = props.errorCode || 404;
  return (
    <div className="error--main-style">
      <div className="error--center-styling">
        <span className="error--heading-style">{errorCode}</span>
        {errorCode === 404 ?
          <p>
            <Localized
              modelName="error404"
              modelKey="error404Description"
              modelAttribute="label"
            />
            <a
              className="error--link-style"
              href={footer.userGuide}
              target="_blank"
            >
              <Localized
                modelName="error404"
                modelKey="error404UserGuideLinkText"
                modelAttribute="label"
              />
            </a>
            <Localized
              modelName="error404"
              modelKey="error404DescriptionLineTwo"
              modelAttribute="label"
            />
            <br />
            <Localized
              modelName="error404"
              modelKey="error404Options"
              modelAttribute="label"
            />
            <Link className="error--link-style" to="/">
              <Localized
                modelName="error404"
                modelKey="error404Link"
                modelAttribute="label"
              />
            </Link>
          </p> :
          <p>Looks like something went wrong!</p>
        }
      </div>
    </div>
  );
};

export default Error;
